var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0326,
    cy: 23.0318,
    r: 23,
    transform: "rotate(0.0792175 23.0326 23.0318)",
    fill: "#FFD26A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0375 19.5318L23.031 24.1984",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1364 13.2186L11.6575 28.9952C11.4621 29.3326 11.3584 29.7152 11.3568 30.1051C11.3551 30.4949 11.4556 30.8784 11.6481 31.2174C11.8407 31.5564 12.1186 31.8391 12.4543 32.0373C12.79 32.2355 13.1717 32.3424 13.5616 32.3474L32.4779 32.3735C32.8676 32.3696 33.2494 32.2637 33.5855 32.0664C33.9216 31.8692 34.2002 31.5874 34.3936 31.2491C34.5871 30.9109 34.6887 30.5278 34.6882 30.1382C34.6878 29.7485 34.5854 29.3657 34.3912 29.0278L24.956 13.2228C24.7575 12.8941 24.4776 12.6221 24.1433 12.4332C23.809 12.2443 23.4317 12.1447 23.0477 12.1442C22.6637 12.1437 22.2861 12.2422 21.9513 12.4302C21.6165 12.6182 21.3358 12.8893 21.1364 13.2175L21.1364 13.2186Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0262 27.6984L23.0378 27.6985",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/Icon_Warning_Yellow.c73b4471755972dc8380c88ada973048.svg";
export { ForwardRef as ReactComponent };